module.exports = __webpack_public_path__ + "static/media/story-banner.e53731b6.svg";